import * as React from 'react'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { Helmet } from 'react-helmet'
import { PageContentShell, PageViewport } from '../../components/PageLayout'
import { FooterBarComponent } from '../FooterBar'
import { RegisterSteps } from './config'
import { CreateLoginComponent } from '../Login/Create'
import { getTopbarHeight, useDimensions } from '../../hooks/useDimensions'
import { CreateProfileComponent } from '../Profile'
import { SelectUnitsComponent } from '../SelectUnits'
import { UnitsMapComponent } from '../SelectUnits/UnitsMap'
import { getActiveStep } from './selectors'
import { useSelector, useDispatch } from 'react-redux'
import { actions } from './reducer'
import { SummaryComponent } from '../Summary'
import { PaymentComponent } from '../Payment'
import { AppBarComponent } from '../AppBar'
import {
  RegisterPageSurface,
  RegisterStepper,
  RegisterWorkspace,
} from './styled'

export const RegisterComponent = () => {
  const activeStep = useSelector(getActiveStep)
  const dispatch = useDispatch()
  const { height, width } = useDimensions()
  const topbarHeight = getTopbarHeight(width)
  const workspaceHeight = React.useMemo(
    () => Math.max(420, height - topbarHeight - 130),
    [height, topbarHeight]
  )

  React.useEffect(() => {
    dispatch(actions.onActiveStep(0))
  }, [])

  const getComponent = (step: number) => {
    switch (step) {
      case 0:
        return <CreateLoginComponent />
      case 1:
        return <CreateProfileComponent />
      case 2:
        return <SelectUnitsComponent />
      case 3:
        return <UnitsMapComponent />
      case 4:
        return <SummaryComponent />
      case 5:
        return <PaymentComponent />
      default:
        return <UnitsMapComponent />
    }
  }

  return (
    <>
      <Helmet>
        <title>Register || JustLockIt</title>
        <meta name="keywords" content="HTML,CSS,JavaScript" />
        <meta
          name="description"
          content="justlockit.com registration page. storage units Schulenburg, Texas"
        />
      </Helmet>
      <AppBarComponent />
      <PageViewport className="register-page" viewportHeight={height}>
        <PageContentShell
          className="register-page__shell"
          topbarHeight={topbarHeight}
        >
          <RegisterPageSurface className="register-page__surface">
            <RegisterStepper
              className="register-page__stepper"
              activeStep={activeStep}
            >
              {RegisterSteps.map(({ title, width }) => {
                return (
                  <Step
                    className="register-page__step"
                    sx={{ minWidth: width, maxWidth: width }}
                    key={title}
                  >
                    <StepLabel>{title}</StepLabel>
                  </Step>
                )
              })}
            </RegisterStepper>
            <RegisterWorkspace
              className="register-page__workspace"
              contentHeight={workspaceHeight}
            >
              {getComponent(activeStep)}
            </RegisterWorkspace>
          </RegisterPageSurface>
        </PageContentShell>
      </PageViewport>
      <FooterBarComponent />
    </>
  )
}
